import HTTP from "../../http-common"

export function changeCompany(userID, company, role) {
	let data = { company, role }
	return HTTP.put(`users/change_company/${userID}`, data)
}